const prePaymentStageMap = {
  'processingpayment': {
    stage: 0,
    label: { en: 'Processing Payment', ar: 'جاري معالجة الدفع' },
    component: 'PrePaymentProcessingPayment'
  },
  'pending': {
    stage: 1,
    label: { en: 'Payment Confirmed', ar: 'تم تأكيد الدفع' },
    component: 'PrePaymentPending'
  },
  'processing': {
    stage: 2,
    label: { en: 'Preparing Order', ar: 'جاري تحضير الطلب' },
    component: 'PrePaymentProcessing'
  },
  'out for delivery': {
    stage: 3,
    label: { en: 'Out for Delivery', ar: 'قيد التوصيل' },
    component: 'PrePaymentOutForDelivery'
  },
  'delivered': {
    stage: 4,
    label: { en: 'Delivered', ar: 'تم التسليم' },
    component: 'PrePaymentDelivered'
  },
  // ✅ NEW: Add Feedback stage
  'feedback': {
    stage: 5,
    label: { en: 'Feedback', ar: 'التقييم' },
    component: 'PrePaymentFeedback'
  },
  'completed': {
    stage: 5,
    label: { en: 'Completed', ar: 'مكتمل' },
    component: 'PrePaymentFeedback'
  }
};

export const getPrePaymentStageIndex = (status) => {
  if (!status) return 0;
  const normalized = status.toLowerCase().trim();
  const stageInfo = prePaymentStageMap[normalized];
  return stageInfo ? stageInfo.stage : 0;
};

export default prePaymentStageMap;
